import { format } from "date-fns";
import { useNavigate } from "react-router-dom";
import styles from "../../styles/_containers/_giftCards/table.module.scss";
import { paths } from "../../routes/paths";

const Table = ({ data }) => {
  const navigate = useNavigate();

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <h2>היסטוריית שימוש בגיפט קארדס</h2>
      </div>
      <div className={styles.tableWrapper}>
        <table>
          <thead>
            <tr>
              <th>שם</th>
              <th>קוד</th>
              <th>מחיר</th>
              <th>remaining balance</th>
              <th>no of consumers</th>
              <th>רוכש</th>
              <th>סטטוס </th>
              <th>נרכש בתאריך</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {data.length === 0 && (
              <tr>
                <td colSpan={10}>
                  <p>לא בוצעו רכישות</p>
                </td>
              </tr>
            )}
            {data.map((i) => (
              <tr key={i._id}>
                <td>{i.giftCardId.name}</td>
                <td>{i.userGiftCardId.code}</td>
                <td>₪{i.price}</td>
                <td>₪{i.userGiftCardId.remainingBalance}</td>
                <td>{i.userGiftCardId.noOfConsumers}</td>
                <td>{i.userId.name}</td>
                <td>
                  <button
                    className={`${
                      i.paymentStatus === "FAILED" ? styles.red : styles.green
                    }`}
                  >
                    {i.paymentStatus === "COMPLETED" ? "פעיל" : "לא פעיל"}
                  </button>
                </td>
                <td>{format(new Date(i.createdAt), "dd/MM/yyyy")}</td>
                <td
                  onClick={() =>
                    navigate(
                      paths.giftCardConsumptionHistoryByCode(
                        i.userGiftCardId.code
                      )
                    )
                  }
                >
                  <span 
                  style={{backgroundColor:'#DE1468',
                   color:'white',
                    padding:'0 5px',
                    borderRadius:"8px",
                     cursor:'pointer'}}
                     >היסטוריית שימוש</span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default Table;
